import React, { useState, useEffect } from "react";
import Unsplash, { toJson, createApi } from "unsplash-js";
import { HiDownload } from 'react-icons/hi';
import { GoSearch } from 'react-icons/go';
import { saveAs } from 'file-saver';

import topics from './data/topics.json';

const unsplash = new Unsplash({
    accessKey: "11LGp2iqbMqqGq2uVvASiIpj4wix0Go4_-dMSduNhlA",
});

const SearchPhotos = () => {
    const [query, setQuery] = useState("");
    const [pics, setPics] = useState([]);

    const searchPhotos = async (e) => {
        e.preventDefault();
        let inputValue = await document.getElementById("search-value").value;
        let inputElement = await document.getElementById("form");
        let warningAlert = await document.getElementById("warning");

        if (inputValue) {
            let loadingSpan = await document.getElementById("load");
            let results = await document.getElementById("results");
            loadingSpan.style.display = "grid";

            inputElement.style.borderColor = "#eee";
            warningAlert.style.display = "none";

            unsplash.search
                .photos(query, 1, 1000)
                .then(toJson)
                .then(async (json) => {
                    setPics(json.results);
                    results.innerHTML = "...";
                    setTimeout(() => {
                        let cards = document.querySelectorAll(".card");
                        for (let i = 0; i <= cards.length; i++) {
                            if (cards[i]) cards[i].style.display = "flex";
                        }

                        loadingSpan.style.display = "none";
                        if (json.results.length <= 1) {
                            results.innerHTML = `
                            <h1>${inputValue}</h1>
                            <b>${json.results.length}</b> Photo of "<b>${inputValue}</b>"
                        `;
                        } else if (json.results.length > 1) {
                            results.innerHTML = `
                            <h1>${inputValue}</h1>
                            Found <b>${json.results.length}</b> Photos of "<b>${inputValue}</b>"
                        `;
                        }

                        setTimeout(() => {
                            let cardsImages = document.querySelectorAll(".card");
                            for (let j = 0; j <= cardsImages.length; j++) {
                                cardsImages[j].style.filter = "blur(0px)";
                            }
                        }, 500);
                    }, 3700);
                });
        } else {
            inputElement.style.borderColor = "#b90000";
            warningAlert.style.display = "block";
        }
    };

    const searchTopic = async (topic, topicDescription) => {
        let inputValue = await document.getElementById("search-value").value;
        let inputElement = await document.getElementById("form");
        let warningAlert = await document.getElementById("warning");

        if (inputValue) {
            let loadingSpan = await document.getElementById("load");
            let results = await document.getElementById("results");
            loadingSpan.style.display = "grid";

            inputElement.style.borderColor = "#eee";
            warningAlert.style.display = "none";

            unsplash.search
                .photos(topic, 1, 1000)
                .then(toJson)
                .then(async (json) => {
                    setPics(json.results);
                    results.innerHTML = "...";
                    setTimeout(() => {
                        let cards = document.querySelectorAll(".card");
                        for (let i = 0; i <= cards.length; i++) {
                            if (cards[i]) cards[i].style.display = "flex";
                        }

                        loadingSpan.style.display = "none";
                        if (json.results.length <= 1) {
                            results.innerHTML = `
                            <h1>${inputValue}</h1>
                            <p>${topicDescription}</p>
                            `;
                        // <b>${json.results.length}</b> Photo of "<b>${inputValue}</b>"
                        } else if (json.results.length > 1) {
                            results.innerHTML = `
                            <h1>${inputValue}</h1>
                            <p>${topicDescription}</p>
                            `;
                        }
                        // Found <b>${json.results.length}</b> Photos of "<b>${inputValue}</b>"

                        setTimeout(() => {
                            let cardsImages = document.querySelectorAll(".card");
                            for (let j = 0; j <= cardsImages.length; j++) {
                                cardsImages[j].style.filter = "blur(0px)";
                            }
                        }, 500);
                    }, 3700);
                });
        } else {
            inputElement.style.borderColor = "#b90000";
            warningAlert.style.display = "block";
        }
    };


    return (
        <div className="wrapper">
            <h1>Feel free to explore some high resolution photos and images.</h1>
            <p>Dive deep into the world of shots quality with Veta.</p>
            <form className="form" id="form" onSubmit={searchPhotos}>
                <GoSearch className="search-icon" />
                <input
                    type="search"
                    name="query"
                    className="input"
                    id="search-value"
                    placeholder={`Try "atay" or "tajine"`}
                    autoComplete="off"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <button type="submit" className="button" title="Search">
                    <img src="https://img.icons8.com/material/24/ffffff/search--v1.png" height="20px" width="20px" />
                    <span>Search</span>
                </button>
            </form>
            <span className="warning" id="warning">This input is required</span>

            <div className="topics">
                {
                    topics.map((topic) =>
                    <button
                    id="topic-button"
                    key={topic.id}
                    title={topic.title}
                    onClick={() => {
                        let input = document.getElementById("search-value");
                        input.value = topic.title;
                                searchTopic(topic.title, topic.description);
                            }}
                        >
                            {topic.title}
                        </button>
                    )
                }
            </div>

            <div className="load" id="load">
                <span id="loading"></span>
                <p>Loading...</p>
            </div>

            <div className="Search-Results">
                <span id="results"></span>
            </div>

            <div className="card-list">
                {pics ? pics.map((pic) =>
                    <div className="card" key={pic.id}>
                        <span className="image-color" title="Dominated color" style={{ backgroundColor: `${pic.color}` }}></span>
                        <img
                            className="card--image"
                            alt={pic ? pic.alt_description : null}
                            src={pic ? pic.urls.regular : null}
                            width="50%"
                            height="50%"
                            title={pic ? pic.alt_description : null}
                            loading="lazy"
                        />
                        <h4 className="image-title">
                            <a
                                href={pic.user.instagram_username ? `https://instagram.com/${pic.user.instagram_username}` : pic.user.links.html}
                                target="_blank"
                                title={pic.user.instagram_username ? `${pic.user.name} on Instagram` : `${pic.user.name} on Unsplash`}
                            >
                                <img src={pic.user.profile_image.small} />
                                <div className="text">
                                    <span>
                                        {
                                            pic ? pic.user.name : null
                                        }
                                    </span>
                                    <span>
                                        {
                                            pic.user.for_hire == true ? `• Available for hire` : null
                                        }
                                    </span>
                                </div>
                            </a>
                        </h4>
                        <div
                            id="download-action"
                            className="download-action">
                            <button
                                title="Download photo"
                                onClick={
                                    () => {
                                        saveAs(pic.urls.full, pic.alt_description)
                                    }
                                }
                                >
                                <HiDownload className="download-icon" />
                            </button>
                        </div>
                        <div className="half-transparent"></div>
                    </div>
                    ) : null
                }
            </div>
        </div>
    );
}

export default SearchPhotos;